import React from "react";
import ReactDOM from "react-dom/client";
import { ChatUI } from "./components/chatUI";
import './index.css';
interface HostieChatOptions {
  apiKey: string;
  openAi?: string;
  containerId?: string;
}

export function init({
  apiKey,
  openAi,
  containerId = "hostie-chat-root",
}: HostieChatOptions) {
  let container = document.getElementById(containerId);
  if (!container) {
    container = document.createElement("div");
    container.id = containerId;
    document.body.appendChild(container);
  }

  const root = ReactDOM.createRoot(container);
  root.render(<ChatUI apiKey={apiKey} openAi={openAi} />);
}

export { ChatUI };

// Expose globally for CDN usage
if (typeof window !== "undefined") {
  (window as any).HostieChat = { init };
}
